import { useEffect } from "react";
import { useLocation } from "wouter";

const ScrollToTop = () => {
    const [location] = useLocation();

    useEffect(() => {
        // Ensure scroll fires after page content is rendered
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, [location]);

    return null;
};

export default ScrollToTop;
